<template>
  <div class="">
    <m-product-offer1 :offer-status="offerStatus" :offer-type="offerType" class="position-absolute" :product="product"/>
    <div class="position-absolute quantity-status-over-image"
         v-if="quantityStatus(product)">
      <p v-t="`product.out_of_quantity`"></p>
    </div>
    <m-card903 :alt="product.name" :image="product.thumbnail" link-target="_blank"
               :image-link="{ name: 'Product', params: { name: product.raw_link } }">

      <m-a :target="`_blank`" :href="{ name: 'Product', params: { name: product.raw_link } }">
        <h6 class="product-card-903-text">{{ contentSlicer(product.name, 30) }}</h6>
      </m-a>

      <m-product-price100 class="text-center" :product="product"/>

      <m-product-card-quantity-manager1 :in-active-quantity-manager="inActiveQuantityManager" class="text-center"
                                        :product="product"/>

    </m-card903>
  </div>

</template>

<script>
import mCard903 from "../../Cards/Card903";
import mProductCardQuantityManager1 from "../../Product/QuantityManager/Card/ProductCardQuantityManager1";
import mProductPrice100 from "../../Product/ProductPrice100";
import mA from '../../Tags/A'
import mProductOffer1 from "../../Product/ProductOffer/ProductOffer1";
import {OfferProps} from '../ProductOffer/ProductOfferProps'
import {shoppingCartFunctions} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ShoppingCartFunctions";

export default {
  name: "ProductCard903s",
  components: {mCard903, mProductCardQuantityManager1, mA, mProductPrice100, mProductOffer1},
  props: {
    product: {},
    productCardLink: {
      default: '_self',
    },
    inActiveQuantityManager: {
      type: Boolean,
      default: true
    },
    OfferProps
  },
  methods: {
    ...shoppingCartFunctions,
  }
}
</script>

<style scoped>
.quantity-status-over-image {
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(255, 255, 255, .9);
  text-align: center;
  opacity: .9;
  width: 89%;
  padding: 15px 0;
  z-index: 4;
}
</style>